export type VisiblePageItem = number | 'ellipsis'

export const getVisiblePages = (currentPage: number, totalPages: number): number[] => {
    if (totalPages < 1) {
        return []
    }

    let edgePages: number[] = []

    if (currentPage === 1) {
        edgePages = [currentPage + 2]
    } else if (currentPage === totalPages) {
        edgePages = [currentPage - 2]
    }
    const pages = new Set([
        1,
        totalPages,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        Math.round((currentPage + 1) / 2),
        Math.round((currentPage + totalPages) / 2),
        ...edgePages,
    ])

    return [...pages].filter((page) => page >= 1 && page <= totalPages).sort((left, right) => left - right)
}

export const getVisiblePageItems = (currentPage: number, totalPages: number): VisiblePageItem[] => {
    const pages = getVisiblePages(currentPage, totalPages)

    return pages.flatMap((page, index) => {
        const nextPage = pages[index + 1]

        if (nextPage !== undefined && nextPage - page > 1) {
            return [page, 'ellipsis']
        }

        return [page]
    })
}
